import { cn } from "cn";
import { splitFileName } from "@/libs/file-helper";

/** "{FileName}.{ext}" — the name truncates first, the extension stays readable. */
export function AttachmentFileName({
  fileName,
  className,
}: {
  fileName: string;
  className?: string;
}) {
  const { base, extension } = splitFileName(fileName);
  return (
    <span
      title={fileName}
      className={cn("flex min-w-0 text-sm text-text-dark-max", className)}
    >
      <span className="truncate">{base}</span>
      <span className="shrink-0">{extension}</span>
    </span>
  );
}
